//亚太财险用户登录专用页

<template></template>
<script>
  export default {
    name: 'ytlogin',
    data() {
      return {
        code:''
      }
    },
    activated(){
      this.jump()
    },
    created() {
      let b = this.jump();
        if(!this.$route.query.code){
            this.$router.push('/login')
        }else{
            this.code = this.$route.query.code;
            b && this.sub();
        }
        
    },
    methods: {     
      jump(){
        if(window.sessionStorage.getItem('fromYT')){
          window.sessionStorage.removeItem('fromYT');
          location.href = 'https://sys.apiins.com/'
          return false;
        }else{
          return true;
        }
      },
      sub() {     
        this.$http.get('/api/user/yataiLogin?code='+encodeURIComponent(this.code)).then(
          res => {
            if (res.data.status == 2000) {
              this.$store.commit('setusemessage', res.data.data);             
              window.sessionStorage.setItem("URL",res.data.data.endpoint_software_window_download_url)
              window.sessionStorage.setItem('Time',res.data.data.sync_now_meeting_each_seconds)
              window.sessionStorage.setItem('UUID', res.data.data.useruuid);// 将uuid设置到本地缓存中
              window.localStorage.setItem('UUID', res.data.data.useruuid)
              window.sessionStorage.setItem('userStatus', res.data.data.admin_level);//
              window.sessionStorage.setItem('userID', res.data.data.userID);
              window.sessionStorage.setItem('JSESSIONID', res.data.data.sid);
              window.sessionStorage.setItem('fromYT',1);
              this.$router.push('/index');
            } else {
            //   this.$toast(res.data.data.errorDes)
                this.$toast(this.$t('m.LoginError'))
              setTimeout(()=>{
                  this.$router.push('/login')
              },2500)
            }
          },
        )
        //
      }
    }
  }
</script>
<style scoped>
.ytlogin {
    min-height: 300px;
    display: flex;
    justify-content: center;
    align-items:center;
}
</style>



// WEBPACK FOOTER //
// src/components/login/ytlogin.vue